import {PathName} from '@/constant/routeData';

const UNVISIBLE_SIDE = 'UNVISIBLE_SIDE'
const SET_ASIDEHIDDEN = 'SET_ASIDEHIDDEN'
export default {
  state: {
    sidebarVisible: true,
    asideHidden: false,
    side_menu: [
      {
        text: 'Dashboard',
        url: PathName.Dashboard,
        route: {name: PathName.Dashboard},
        icon: 'el-icon-s-home'
      },
      {
        text: 'Weekly Report',
        icon: 'el-icon-document',
        url: PathName.Report,
        route: {name: PathName.Report},
        sub_menu: [
          {
            text: 'Report',
            url: PathName.WeeklyReport,
            route: {name: PathName.WeeklyReport}},
          {
            text: 'Report List',
            url: PathName.ReportList,
            route: {name: PathName.ReportList},
          },
          {
            text: 'All Report',
            url: PathName.AdminReport,
            route: {name: PathName.AdminReport},
          },
          {
            text: 'Report Summary',
            url: PathName.ReportSummary,
            route: {name: PathName.ReportSummary},
          },
          {
            text: 'Summary-CN',
            url: PathName.ExSummary,
            route: {name: PathName.ExSummary},
          },
        ]
      },
      {
        text: 'Attendance',
        icon: 'el-icon-date',
        url: PathName.Attendance,
        route: {name: PathName.Attendance},
        sub_menu: [
          {
            text: 'Leave Request',
            url: PathName.AttRequest,
            route: {name: PathName.AttRequest}},
          {
            text: 'Leave Calendar',
            url: PathName.AttCalendar,
            route: {name: PathName.AttCalendar},
          },
          {
            text: 'Leave Details',
            url: PathName.AttList,
            route: {name: PathName.AttList},
          },
          {
            text: 'Leave Status',
            url: PathName.AttStatus,
            route: {name: PathName.AttStatus},
          },
          {
            text: 'Leave Transfer',
            url: PathName.AttTrans,
            route: {name: PathName.AttTrans},
          },

        ]
      },

      {
        text: 'Projects',
        icon: 'el-icon-document-add',
        url: PathName.Project,
        route: {name: PathName.Project},
        sub_menu: [
          {
            text: 'Create',
            url: PathName.ProjectInit,
            route: {name: PathName.ProjectInit}
          },
          {
            text: 'Search',
            url: PathName.ProjectList,
            route: {name: PathName.ProjectList}
          },
          {
            text: 'Summary',
            url: PathName.ProjectSummary,
            route: {name: PathName.ProjectSummary}
          },
          {
            text: 'Kanban',
            url: PathName.ProjectKanban,
            route: {name: PathName.ProjectKanban}
          }
        ]
      },
      {
        text: 'Reqs.',
        icon: 'el-icon-s-order',
        url: PathName.Requirement,
        route: {name: PathName.Requirement},
        sub_menu: [
          {
            text: 'Create',
            url: PathName.ReqRequest,
            route: {name: PathName.ReqRequest},
          },
          {
            text: 'Search',
            url: PathName.ReqList,
            route: {name: PathName.ReqList},
          },
          {
            text: 'Summary',
            url: PathName.ReqSummary,
            route: {name: PathName.ReqSummary},
          },
        ]
      },
      // {
      //   text: 'Tasks',
      //   icon: 'el-icon-s-order',
      //   url: PathName.Task,
      //   route: {name: PathName.Task},
      //   sub_menu: [
      //     {
      //       text: 'Create',
      //       url: PathName.TaskAdd,
      //       route: {name: PathName.TaskAdd},
      //     },
      //     {
      //       text: 'Search',
      //       url: PathName.TaskList,
      //       route: {name: PathName.TaskList},
      //     },
      //     {
      //       text: 'Kanban',
      //       url: PathName.TaskKanban,
      //       route: {name: PathName.TaskKanban},
      //     },
      //     {
      //       text: 'Summary',
      //       url: PathName.TaskSummary,
      //       route: {name: PathName.TaskSummary},
      //     },
      //   ]
      // },

    ]
  },
  getters: {
    isSideBar: state => {
      return state.sidebarVisible
    }
  },
  mutations: {
    [UNVISIBLE_SIDE](state, isvisible) {
      state.sidebarVisible = isvisible
    },
    [SET_ASIDEHIDDEN](state, isvisible) {
      state.asideHidden = isvisible
    }
  },
  actions: {},
}
